import React from 'react';
import { EditButton, ListButton, TopToolbar } from 'react-admin';
import { useACL } from '../../access-control';
import DOCXLicenseAgreementButton from './DOCXLicenseAgreementButton';
import { ContractActionsProps } from './types';

const ContractActions: React.FC<ContractActionsProps> = (props) => {
  const { edit } = useACL('contract');

  return (
    <TopToolbar>
      <ListButton label="Список" basePath={props.basePath} />
      {edit && (
        <EditButton
          label="Редактировать"
          record={props.data}
          basePath={props.basePath}
          resource={props.resource}
        />
      )}
      <DOCXLicenseAgreementButton recordId={props.data.id.toString()} />
    </TopToolbar>
  );
};

export default React.memo(ContractActions);
